import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "pianoconticfs",
    defaultRoutePath: "/cashflows/pianoconticf",
    menuItemScope: "cashflows",
    menuItemName: "pianoconticfs",
    routes: [
        {
            path: "/cashflows/pianoconticf",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
